import React from "react";
import {
  MDBFooter,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBIcon,
} from "mdb-react-ui-kit";
import { Container, Row, Col } from "react-bootstrap";
import LocationIcon from "../../assets/icons/LocationIcon.svg";
import MailIcon from "../../assets/icons/MailIcon.svg";
import ContentData from "../../constants/Contents.json"

import "./footer.css";

const Footer = () => {
  return (
    <MDBFooter
      style={{ backgroundColor: "#170D11" }}
      className="vgFooter text-center text-lg-start "
      color="light"
    >
      <Container className="lowerSectionFooter">
        <Col>
          <p className="footerText" style={{ fontWeight: "300" }}>
            {ContentData.footer.copyRight}
          </p>
        </Col>
        <Col>
          <div className="lowerSectionText">
            <p className="footerText">Privacy Policy</p>
            <p className="footerText">Terms and Conditions </p>
            <p className="footerText">Disclaimer</p>
            <p className="footerText">Legal</p>
            <p className="footerText">Site Map</p>
          </div>
        </Col>
      </Container>
    </MDBFooter>
  );
};

export default Footer;
